import { FC } from 'react';
import { Flex } from '@servicetitan/anvil2';

import { TelecomBrandData } from '../api/telecom.api';
import { SectionCard } from './section-card';
import { LabelText, FieldText } from '../components/text-components';

interface BrandDetailsCardProps {
    brand: TelecomBrandData;
}

export const BrandDetailsCard: FC<BrandDetailsCardProps> = ({ brand }) => {
    const { details } = brand;

    return (
        <SectionCard title="Brand Details">
            <Flex direction="row" gap="4">
                <Flex direction="column" gap="4">
                    <LabelText>DBA Name</LabelText>
                    <LabelText>Legal Name</LabelText>
                    <LabelText>EIN</LabelText>
                    <LabelText>Phone Number</LabelText>
                    <LabelText>Street Address</LabelText>
                    <LabelText>City</LabelText>
                    <LabelText>State</LabelText>
                    <LabelText>Zip Code</LabelText>
                    <LabelText>Country</LabelText>
                    <LabelText>Email</LabelText>
                    <LabelText>Website</LabelText>
                    <LabelText>Is Publicly Traded</LabelText>
                    <LabelText>Stock Symbol</LabelText>
                    <LabelText>Stock Exchange</LabelText>
                    <LabelText>Alt Business ID</LabelText>
                    <LabelText>Alt Business ID Type</LabelText>
                </Flex>

                <Flex direction="column" gap="4">
                    <FieldText>{details.dbaName || '-'}</FieldText>
                    <FieldText>{details.legalName || '-'}</FieldText>
                    <FieldText>{details.ein || '-'}</FieldText>
                    <FieldText>{details.phoneNumber || '-'}</FieldText>
                    <FieldText>{details.streetAddress || '-'}</FieldText>
                    <FieldText>{details.city || '-'}</FieldText>
                    <FieldText>{details.state || '-'}</FieldText>
                    <FieldText>{details.zipCode || '-'}</FieldText>
                    <FieldText>{details.country || '-'}</FieldText>
                    <FieldText>{details.email || '-'}</FieldText>
                    <FieldText>{details.website || '-'}</FieldText>
                    <FieldText>
                        {details.isPubliclyTraded !== undefined
                            ? details.isPubliclyTraded
                                ? 'Yes'
                                : 'No'
                            : '-'}
                    </FieldText>
                    <FieldText>{details.stockSymbol || '-'}</FieldText>
                    <FieldText>{details.stockExchange || '-'}</FieldText>
                    <FieldText>{details.altBusinessId || '-'}</FieldText>
                    <FieldText>{details.altBusinessIdType || '-'}</FieldText>
                </Flex>
            </Flex>
        </SectionCard>
    );
};
